var utils = require( './utils' );

var booking_popup = ( function( $ ) {

	var $popup,
		$overlay;

	var _init = function() {
		$popup   = $( '#booking-popup' );
		$overlay = $( '<div id="site-overlay" style="display: none"></div>' );

		$popup.find( 'a.close-popup' ).on( 'click', _hide );

		_setup_links();
	};

	var _maybe_hide = function() {
		if ( $( 'body' ).hasClass( 'open-booking-popup' ) ) {
			_hide();
		}
	};

	var _overlay_site = function() {
		$( '#site-wrapper' ).append( $overlay );

		$overlay.on( 'click', _maybe_hide );
		
		setTimeout( function() {
			$overlay.fadeIn();
		}, 100 )
	};

	var _remove_overlay = function() {
		$overlay.fadeOut( 200 );

		setTimeout( function() {
			$overlay.remove();
		}, 200 )
	};

	var _popup = function() {
		_overlay_site();
		$popup.fadeIn( 200 );
		setTimeout( function() {
			$( 'body' ).addClass( 'open-booking-popup popup-open' );
			_set_col_heights();
		}, 200 );
	};

	var _set_col_heights = function(  ) {
		if ( utils.viewport_size().width <= 768 ) {
			return;
		}

		var $cols = $popup.find( '.right, .left' ),
			height = 0;

		$cols.css( 'height', 'auto' );

		$cols.each( function( index, item ) {
			if ( $( item ).outerHeight() > height ) {
				height = $( item ).outerHeight();
			}
		} );

		$cols.css( 'height', height );
	};

	var _hide = function() {
		$popup.fadeOut( 200 );
		_remove_overlay();
		
		setTimeout( function() {
			$( 'body' ).removeClass( 'open-booking-popup popup-open' );
		}, 200 );
	};

	var _setup_links = function() {
		var $links = $( '.popup-booking' );

		$links.on( 'click', function( e ) {
			e.stopImmediatePropagation();
			e.preventDefault();

			_popup();
		} );
	};

	if ( $( '#booking-popup' ) ) {
		$( document ).ready( _init );
	}

} ) ( jQuery );

module.exports = booking_popup;